<template>
  <el-container style="height: 100%">
    <el-header class="header">
      <div class="header_left">
        <!-- <div>
          <img src="@/assets/img/logo.png" alt="" />
        </div> -->
        <div>软件自动更新管理系统</div>
      </div>
      <div class="header_right">
        <el-avatar icon="el-icon-user-solid" size="medium" class="avatar"></el-avatar>
        <span>{{ userName }}</span>
        <span class="iconfont" @click="signOut">&#xe631;</span>
      </div>
    </el-header>
    <el-container class="outContainer">
      <el-aside width="200px" class="aside">
        <!-- <el-menu
          text-color="#fff"
          class="el-menu-vertical-demo">
            <div v-for="(item, index) in menus" :key="index" :class="{'active-menu':item.link===currentlink}">
              <router-link :to="item.link" >
                <el-menu-item>
                  <i :class="item.icon"></i>
                  <span slot="title">{{item.text}}</span>
                </el-menu-item>
              </router-link>
            </div>
        </el-menu> -->
        <el-menu
          router
          unique-opened
          text-color="#fff"
          :default-active="currentlink"
          class="el-menu-vertical-demo"
        >
          <div
            v-for="(item, index) in menus"
            :key="index"
            :class="{
              'active-menu':
                currentlink.indexOf(item.link) != -1 || secondlink.indexOf(item.link) != -1
            }"
          >
            <div v-if="item.children.length > 0">
              <el-submenu :index="item.link">
                <template slot="title">
                  <!-- <i :class="item.icon"></i> -->
                  <img
                    class="mr-sm"
                    :src="require(`@/assets/img/${item.icon}`)"
                    alt=""
                    width="16"
                  />
                  <span>{{ item.text }}</span>
                </template>
                <el-menu-item-group title="">
                  <el-menu-item
                    v-for="(child, index_c) in item.children"
                    :key="index_c"
                    :index="child.link"
                  >
                    <img
                      class="mr-sm"
                      :src="require(`@/assets/img/${child.icon}`)"
                      alt=""
                      width="16"
                    />
                    {{ child.text }}
                  </el-menu-item>
                </el-menu-item-group>
              </el-submenu>
            </div>
            <div v-else>
              <el-menu-item :index="item.link">
                <img class="mr-sm" :src="require(`@/assets/img/${item.icon}`)" alt="" width="16" />
                <span slot="title">{{ item.text }}</span>
              </el-menu-item>
            </div>
          </div>
        </el-menu>
      </el-aside>
      <el-main>
        <bread-crumb></bread-crumb>
        <router-view />
      </el-main>
      <global-upload
        ref="globalUpload"
        :showUpload.sync="showUpload"
        @refreshDataList="refreshList"
      ></global-upload>
    </el-container>
  </el-container>
</template>

<script>
import BreadCrumb from '@/components/BreadCrumb'
import GlobalUpload from '@/components/GlobalUpload'
import bus from './../utils/bus'
export default {
  data() {
    return {
      uploadVisible: true,
      userName: '',
      currentlink: '',
      secondlink: '',
      menus: [],
      showUpload: false,
      perm: '' // 账号权限
    }
  },
  components: { GlobalUpload, BreadCrumb },
  // 监听,当路由发生变化的时候执行
  watch: {
    $route(to, from) {
      if (to.path !== '/maintain') {
        this.currentlink = to.path
        this.secondlink = to.path
        this.secondlinkDeal()
      }
    }
  },
  mounted() {
    this.$store.commit('changeNeedMsg', true)
    this.$store.commit('changeStopMsg', true)
    this.currentlink = location.hash.substring(1)
    this.secondlink = location.hash.substring(1)
    this.secondlinkDeal()
    this.getUserName()
    // 监听页面刷新和关闭事件
    window.addEventListener('beforeunload', e => this.beforeUnload(e))
  },
  methods: {
    secondlinkDeal() {
      if (
        this.secondlink.indexOf('/version') !== -1 ||
        this.secondlink.indexOf('/equipment') !== -1
      ) {
        this.secondlink = '/production' + this.secondlink
      }
    },
    refreshList() {
      bus.$emit('refreshVersionList', true)
    },
    checkRoutes() {
      if (this.perm === 'admin') {
        this.menus = [
          {
            text: '系统管理',
            link: '/manage',
            icon: 'system.png',
            id: 3,
            children: [
              {
                text: '用户管理',
                link: '/manage/user',
                icon: 'user.png',
                id: 4
              }
            ]
          },
          {
            text: '产品信息',
            link: '/production',
            icon: 'icon_product-info_def.png',
            id: 1,
            children: []
          }
        ]
      } else {
        this.menus = [
          {
            text: '产品信息',
            link: '/production',
            icon: 'icon_product-info_def.png',
            id: 1,
            children: []
          }
        ]
      }
    },
    getUserName() {
      this.$http({
        url: this.$http.adornUrl('/api/app/getUsername'),
        method: 'GET'
      }).then(res => {
        if (res.resp_code === 0) {
          this.userName = res.data.username
          this.perm = res.data.perm
        } else {
          this.userName = 'admin'
          this.$message.error(res.resp_msg)
        }
        this.checkRoutes()
        this.$store.commit('updateUserName', this.userName)
        this.$store.commit('updatePerm', res.data.perm)
      })
    },
    // signOut () {
    //   this.$confirm('确定退出么?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     this.$http({
    //       url: this.$http.adornUrl(`/api/v1/auth/logout`),
    //       method: 'post',
    //       headers: {
    //         Authorization: this.$cookie.get('token')
    //       },
    //       params: this.$http.adornParams()
    //     }).then(res => {
    //       if (res && res.resp_code === 0) {
    //         this.$message({
    //           type: 'success',
    //           message: '退出成功'
    //         })
    //         this.$cookie.delete('token')
    //         this.$router.push('/login')
    //       } else {
    //         this.$message({
    //           type: 'error',
    //           message: res.resp_msg
    //         })
    //       }
    //     })
    //   })
    // },
    // 登出
    signOut() {
      this.$confirm(
        `${
          this.showUpload && !this.$refs.globalUpload.isFinish
            ? '列表中有未完成的上传任务，确定放弃上传吗?'
            : '确定退出么?'
        }`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.$http({
            url: this.$http.adornUrl(`/api/v1/auth/logout`),
            method: 'post',
            params: this.$http.adornParams()
          }).then(res => {
            if (res && res.resp_code === 0) {
              this.$message({
                type: 'success',
                message: '退出成功'
              })
              this.$cookie.delete('token')
              this.$router.push('/login')
            } else if (res && res.resp_code !== 1001) {
              this.$message({
                type: 'error',
                message: res.resp_msg
              })
            }
          })
        })
        .catch(() => {})
    },
    // beforeunload
    beforeUnload(e) {
      if (this.showUpload && !this.$refs.globalUpload.isFinish) {
        // 兼容IE8和Firefox 4之前的版本
        e = e || window.event
        if (e) {
          e.returnValue = '关闭提示'
        }
        return '关闭提示'
      }
    },
    // 存储空间颜色
    colorMethod(percentage) {
      if (percentage < 80) {
        return '#409eff'
      } else {
        return '#f56c6c'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.mr-sm {
  margin-right: 10px;
}

.el-header {
  padding: 0 20px 0 0;
}
$bg-color: #26314f;
.header {
  background: #00001e;
  color: #fff;
  box-sizing: border-box;
  display: -webkit-flex; /* Safari */
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header_left {
  font-size: 22px;
  display: flex;
  display: -webkit-flex; /* Safari */
  align-items: center;
  div:nth-of-type(1) {
    // width: 160px;
    height: 60px;
    line-height: 60px;
    border-radius: 5px;
    text-align: center;
    margin: 0 12px;
    img {
      width: 80px;
      vertical-align: middle;
      margin: 8px 0 0 0;
    }
  }
  div:nth-of-type(2) {
    margin-left: 27px;
  }
}
.header_right {
  width: 170px;
  display: -webkit-flex; /* Safari */
  display: flex;
  justify-content: space-around;
  align-items: center;
  .iconfont {
    font-size: 30px;
    cursor: pointer;
  }
}
.aside {
  height: 100%;
  min-height: calc(100vh - 60px);
  background-color: #545c64;
}
.el-menu {
  background-color: transparent !important;
  border-right: 0 none;
}
.el-menu-item:focus,
.el-menu-item:hover {
  background-color: #707983;
}
a {
  text-decoration: none;
}
.active-menu {
  .el-menu-item,
  .el-submenu__title {
    color: #fff !important;
    background-color: rgba(0, 0, 0, 0.2);
  }
  // .el-menu-item i{
  //   color: #ffd04b !important;
  // }
}
.el-menu-item:focus,
.el-menu-item:hover,
.el-submenu__title:hover {
  background-color: rgba(0, 0, 0, 0.2);
}
.el-menu-item.is-active {
  color: #fff !important;
  background-color: rgba(0, 0, 0, 0.2);
}

.upload-box {
  display: none;
  width: 400px;
  background: #fff;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #d7dae2;
  .upload-head {
    padding: 20px 10px;
    border-bottom: 1px solid #f1f1f1;
    .el-icon-close {
      float: right;
      cursor: pointer;
    }
  }
  .progress-box {
    display: flex;
    padding: 20px;
    margin: 20px 0;
    background: #f1f7fd;
    .percent-line {
      flex: 1;
      padding-top: 5px;
    }
  }
}
.el-menu-item-group__title {
  padding: 0 !important;
}
</style>
